import { createColumnHelper } from "@tanstack/react-table";
import { indexer } from "../../../../utils";
import React from "react";
import { useNavigate } from "react-router-dom";
import {
  fetchFaqDownload,
  useFAQList,
  useUpdatefaq,
} from "../../../../api/inquiries/faq/use-faq";
import Table from "../../../../components/ui/Table/Table";
import dayjs from "dayjs";

const options = [
  { id: "latest", name: "최신순" },
  { id: "createdAt", name: "등록일시 순" },
];

const columnHelper = createColumnHelper();

const columns = (page, pageSize, total) => {
  return [
    columnHelper.accessor((row) => row, {
      header: "번호",
      cell: (info) => {
        const index = info.cell.row.index;
        const indexing = indexer(page, pageSize, total);
        return <div>{indexing(index)}</div>;
      },
    }),

    columnHelper.accessor((row) => row?.faqCategory?.name, {
      header: "분류",
      cell: (info) => {
        const val = info.getValue();

        return <div>{val ? val : "-"}</div>;
      },
    }),

    columnHelper.accessor((row) => row?.status, {
      header: "상태",
      cell: (info) => {
        const val = info.getValue();

        return <div>{val ? (val === "ON" ? "등록" : "미등록") : "미등록"}</div>;
      },
    }),

    columnHelper.accessor((row) => row?.title, {
      header: "제목",
      cell: (info) => {
        const val = info.getValue();
        const title = val?.length > 20 ? val?.substring(0, 20) + "..." : val;

        return <div>{val ? title : "-"}</div>;
      },
    }),

    columnHelper.accessor((row) => row?.hitLog, {
      header: "조회수",
      cell: (info) => {
        const val = info.getValue();

        return <div>{val ? val : "0"}</div>;
      },
    }),

    columnHelper.accessor((row) => row?.createdAt, {
      header: "등록일시",
      cell: (info) => {
        const val = info.getValue();
        const datetime = dayjs(val).format("YYYY-MM-DD HH:mm");
        return <div>{val ? datetime : "-"}</div>;
      },
    }),

    columnHelper.accessor((row) => row?.status, {
      header: "등록관리",
      cell: FaqActions,
    }),

    columnHelper.display({
      header: "자세히보기",
      id: "actions",
      cell: ButtonActions,
    }),
  ];
};

function FaqActions(props) {
  const id = props.row.original?.id;
  const title = props.row.original?.title;
  const contents = props.row.original?.contents;
  const faqCategoryId = props.row.original?.faqCategory?.id;
  const faqCategoryName = props.row.original?.faqCategory?.name;
  const val = props.getValue();
  const { mutate: updateFAQ } = useUpdatefaq();

  const onClickAction = async (status) => {
    const payload = {
      id: id,
      title: title,
      contents: contents,
      faqCategoryId: faqCategoryId,
      status: status,
    };
    await updateFAQ(payload);
  };

  return (
    <div>
      {faqCategoryName !== "분류 미해당" ? (
        val ? (
          val === "ON" ? (
            <button
              type="button"
              className="w-16 p-[1px] rounded-[4px] bg-[#dddddd] text-[#707070] border border-[#cccccc]"
              onClick={() => onClickAction("OFF")}
            >
              등록해제
            </button>
          ) : (
            <button
              type="button"
              className="w-12 p-[1px] border border-[#19459f] rounded-[4px] text-[#19459f]"
              onClick={() => onClickAction("ON")}
            >
              등록
            </button>
          )
        ) : (
          <button
            type="button"
            className="w-12 p-[1px] border border-[#19459f] rounded-[4px] text-[#19459f]"
            onClick={() => onClickAction("ON")}
          >
            등록
          </button>
        )
      ) : (
        "(분류 미해당)"
      )}
    </div>
  );
}

function ButtonActions(props) {
  const id = props.row.original?.id;
  const navigate = useNavigate();
  return (
    <button
      type="button"
      onClick={() => navigate(`faq/${id}`)}
      className="w-10 p-[1px] border border-[#cccccc] rounded-[4px] text-[#333333]"
    >
      확인
    </button>
  );
}

export function FAQTable(props) {
  const { filter } = props;
  const navigate = useNavigate();
  const { isEmpty, getDataTableProps } = useFAQList(filter);
  const currentPage = getDataTableProps().pagination?.pageIndex + 1;
  const pageSize = getDataTableProps().pagination?.pageSize;
  const totalData = getDataTableProps().total;

  const onRegisterNotice = () => {
    navigate("notice/register");
  };
  const onSave = async () => {
    await fetchFaqDownload().then((response) => {
      const url = window.URL.createObjectURL(new Blob([response]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `faq-${Date.now()}.xlsx`);
      document.body.appendChild(link);
      link.click();
    });
  };

  return (
    <>
      {isEmpty ? (
        <div className="flex justify-center mt-[60px] text-[#999999] text-center">
          등록된 내역이 없습니다.
        </div>
      ) : (
        <Table
          hasSave={true}
          onSave={onSave}
          additionalButtonText="공지사항 등록"
          onClickAdditionalButton={onRegisterNotice}
          hasPageSizeFilter={false}
          columns={columns(currentPage, pageSize, totalData)}
          sorts={options}
          width="w-[6rem]"
          {...getDataTableProps()}
        />
      )}
    </>
  );
}
